import type { ComputeRoutePdfLength } from "./types";

export const computeRoutePdfLength: ComputeRoutePdfLength = ({
  nodes,
  edges,
}) => {
  if (nodes.length === 0 || edges.length === 0) return 0;

  const nodeById = new Map(nodes.map((node) => [node.id, node]));

  let totalLength = 0;
  for (const edge of edges) {
    const fromNode = nodeById.get(edge.from);
    const toNode = nodeById.get(edge.to);
    if (!fromNode || !toNode) continue;
    totalLength += Math.hypot(toNode.x - fromNode.x, toNode.y - fromNode.y);
  }

  return totalLength;
};
